module.exports = __webpack_public_path__ + "Physical-4eb75f920fee3eda4080a1d790b2cdd5.png";